import { Attributes, ComponentType, createElement } from 'react';

const mergeProps = (defaultProps: any = {}, props: any = {}): any => {
  const result = { ...defaultProps };
  Object.entries(props).forEach(([key, value]) => {
    if (key in result) {
      if (typeof result[key] === 'object' && typeof value === 'object') {
        result[key] = { ...result[key], ...value };
      } else if (Array.isArray(result[key]) && Array.isArray(value)) {
        result[key] = result[key].concat(value);
      } else {
        result[key] = value;
      }
    } else {
      result[key] = value;
    }
  });
  return result;
};

export function withProps<
  P extends object,
  DP extends Attributes & Partial<P> = Attributes & Partial<P>
>(
  component: ComponentType<P>,
  defaultProps: DP,
  deepMergeProps?: boolean
): ComponentType<
  Attributes & Omit<P, keyof DP> & Partial<Pick<P, Extract<keyof DP, keyof P>>>
> {
  // eslint-disable-next-line react/display-name
  return (props: any) =>
    createElement(
      component,
      deepMergeProps
        ? mergeProps(defaultProps, props)
        : { ...defaultProps, ...props }
    );
}
